// https://www.npmjs.com/package/google-maps-api-loader
import GoogleMapsApiLoader                                     from 'google-maps-api-loader';
import Common                                                  from './common';
import ApiCall                                                 from './apiCall';
import DataLayer                                               from './map/dataLayer';
import Measure                                                 from './map/measure';
import MultiPoint                                              from './map/multiPoint';
import {apiClientWithUserToken as apiClient, apiList, apiTool} from './apiClient';
import axios                                                   from 'axios';
import MovingMyPoint                                           from "./map/movingMyPoint";
import {MVTLayer}                                              from '@deck.gl/geo-layers';
import {GoogleMapsOverlay}                                     from '@deck.gl/google-maps';

export default {
  /**
   * Google Maps Version
   */
  VERSION: '3.63',
  /**
   * Google Maps API KEY
   */
  API_KEY: process.env.VUE_APP_GOOGLE_MAP_API_KEY ? process.env.VUE_APP_GOOGLE_MAP_API_KEY : '',
  /**
   * APIタイムアウト（ms）
   */
  API_TIMEOUT: 30000,
  /**
   * API呼び出しウエイト（ms）
   */
  API_CALL_WAIT: 500,
  /**
   * ローカライズ
   */
  LOCALIZATION: {
    LANGUAGE: 'ja',
    REGION  : 'JP',
  },
  /**
   * ジオコード
   */
  GEO_CODING: {
    ZOOM: 20, // ジオコーディング後のズームレベル
  },
  /**
   * マーカーの定数
   */
  MARKER: {
    BUFFER                     : 0.000005, // マーカークリック時に取得する四方のバッファ（0.000001度≒0.1m）
    ZOOM                       : 20, // Change the zoom level when selected a pdf
    REGISTRIES_REQUEST_MIN_ZOOM: 12, // 取得履歴（マイマーカー）をリクエストできるズーム最小値
  },
  /**
   * カスタムされたマップ名
   */
  CUSTOM_MAP_TYPE_ID: 'styled',
  /**
   * NAベクトルレイヤーURL
   */
  NA_LAYER_URL: process.env.VUE_APP_NA_VECTOR_TILE_URL ? process.env.VUE_APP_NA_VECTOR_TILE_URL : '',
  /**
   * Google Maps Platform
   */
  google: null,
  /**
   * 地図
   */
  map: null,
  /**
   * 地図の初期値
   */
  mapConfig: {
    center               : {
      lat: 35.597072,
      lng: 139.667311
    },
    zoom                 : 19,
    mapTypeId            : 'roadmap',
    clickableIcons       : false,
    mapTypeControlOptions: {
      mapTypeIds: ['roadmap', 'satellite', 'styled']
    },
    gestureHandling      : 'auto',
    draggable            : true,
    zoomControl          : true,
    scaleControl         : true,
    streetViewControl    : true,
    rotateControl        : false,
    fullscreenControl    : false,
    keyboardShortcuts    : true,
    restriction          : {
      latLngBounds: {
        north: 50,
        south: 20,
        west : 120,
        east : 155,
      },
      strictBounds: true,
    },
  },
  /**
   * 地図のスタイル
   */
  featureOpts: [
    {
      featureType: 'landscape',
      elementType: 'geometry.stroke',
      stylers    : [
        {
          color: '#aaaaaa'
        },
        {
          weight: 1
        }
      ]
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers    : [
        {
          color: '#efefef'
        }
      ]
    },
    {
      featureType: 'poi.business',
      stylers    : [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text',
      stylers    : [
        {
          visibility: 'off'
        }
      ]
    }
  ],
  /**
   * Location type of address used in GoogleMap
   * {@link https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingResponses}
   */
  geometryLocationType: ["APPROXIMATE", "ROOFTOP", "RANGE_INTERPOLATED", "GEOMETRIC_CENTER"],
  /**
   * Address type of address used in GoogleMap
   * {@link https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes}
   */
  geocodingAddressType: ["political",
    "locality",
    "sublocality",
    "street_address",
    "route",
    "intersection",
    "country",
    "administrative_area_level_1",
    "administrative_area_level_2",
    "administrative_area_level_3",
    "administrative_area_level_4",
    "administrative_area_level_5",
    "administrative_area_level_6",
    "administrative_area_level_7",
    "colloquial_area",
    "neighborhood",
    "premise",
    "subpremise",
    "plus_code",
    "postal_code",
    "natural_feature",
    "airport",
    "park",
    "point_of_interest",
    "establishment"],
  /**
   * 以前のAPIリクエストをキャンセルするトークン
   */
  cancelToken: {
    setting: null,
    point  : null,
    search : null,
  },
  /**
   * ウィンドウサイズリサイズ中
   */
  onWindowResize: false,
  /**
   * マーカークラスター
   */
  markerCluster: null,
  markerApiCall: new ApiCall(),
  /**
   * 設定反映
   */
  settingApiCall: new ApiCall(),
  /**
   * マーカーが存在するポイントの情報
   */
  dataPoints: [],
  /**
   * オートコンプリート
   */
  autocomplete: null,
  /**
   * ジオコーダー
   */
  geocoder    : null,
  placeService: null,
  /**
   * 右クリック可能なマーカー
   */
  rightClickMarker: null,
  nearbyRadius    : 10, // meters
  /**
   *
   */
  pdfMarkers: [],
  /**
   *
   */
  chibanPolygons: [],
  /**
   *
   */
  chibanOverlays: [],
  /**
   *
   */
  chibanCloses: [],
  /**
   *
   */
  pdfActives: [],
  /**
   * GeoJsonレイヤーに紐付けられたイベントリスナーを格納
   */
  geoJsonHandles: [],
  /**
   * Account status
   */
  accountStatus: false,
  /**
   * Vue Map Google
   */
  vueMapGoogle: null,
  /**
   * Check confirm dialog is show or not
   */
  hasConfirmDialog: false,
  coordInfoWindow : null,
  /**
   * Display my markers or not
   */
  displayMyMarkersFlag: true,
  /**
   * Detach long press
   */
  mouseDownAt     : null,
  mouseDownCenter : null,
  isLongPress     : false,
  longPressTimeout: 100,
  longPressTime   : 300,
  /**
   * Right click position
   */
  rightClickPosition: null,
  /**
   * Support touch
   */
  touchSupported : false,
  multiPointMode : false,
  dataMultiPoints: [],
  infoWindow     : null,
  initPoint      : null,

  isNaLayerHover: false,
  isInterval    : false,
  isNaVisible   : true,

  /**
   * Google Map 初期化
   *
   * @param target
   * @param vueMapGoogle
   * @returns {Promise<void>}
   */
  init: async function (target, vueMapGoogle) {
    const self          = this;
    this.touchSupported = Common.hasTouchSupport();

    // 地図の初期値を設定
    await this.setConfig(vueMapGoogle);
    await GoogleMapsApiLoader({
      libraries: ['geometry', 'places'],
      apiKey   : this.API_KEY,
      language : this.LOCALIZATION.LANGUAGE,
      region   : this.LOCALIZATION.REGION,
      version  : this.VERSION,
    })
      .then(function (google) {
        self.google       = google;
        self.map          = new google.maps.Map(target, self.mapConfig);
        self.geocoder     = new google.maps.Geocoder();
        self.placeService = new google.maps.places.PlacesService(self.map);

        DataLayer.init(self.google, self.map);
        MovingMyPoint.init(self, self.google, self.map, vueMapGoogle);
        if (vueMapGoogle) {
          vueMapGoogle.$emit('getMapInit', self);
        }
      })
      .catch(error => {
        console.error(error);
      });

    // 見た目を設定
    this.setStyle();

    // Handle click event
    this.setClickEvent(vueMapGoogle);

    // 表示範囲よりGeoJsonをオーバーレイ表示
    this.setGeoJson(vueMapGoogle);

    // Update account setting position newest
    this.setAccountSetting();

    this.setInterval();

    // Get pdf registration
    this.updatePdfRegistration(vueMapGoogle);

    // Keyword search
    this.setKeywordSearch(vueMapGoogle);

    // GoogleMapを表示した履歴を残す
    await this.saveHistoryMap();

    if (this.vueMapGoogle) {
      this.initChibanOverlay(this.vueMapGoogle);
    }
    this.initNALayerOverlay();
  },
  /**
   * 地図の初期値を設定
   *
   * @param vueMapGoogle
   * @returns {Promise<void>}
   */
  setConfig: async function (vueMapGoogle) {
    const initCenterPoint = vueMapGoogle.$props.centerPoint;
    let havePropCenter    = false;
    if (initCenterPoint && !Number.isNaN(Number(initCenterPoint.lat)) && !Number.isNaN(Number(initCenterPoint.lng))) {
      havePropCenter        = true;
      this.mapConfig.center = {
        lat: Number(initCenterPoint.lat),
        lng: Number(initCenterPoint.lng)
      };
    }
    if (this.initPoint !== null) {
      havePropCenter        = true;
      this.mapConfig.center = {
        lat: Number(this.initPoint.lat),
        lng: Number(this.initPoint.lng),
      };
    }

    // ユーザーの履歴があればそこから復元
    const accountSetting = await this.getAccountSetting();
    if (!accountSetting.errors) {
      if (!havePropCenter) {
        this.mapConfig.center = {
          lat: accountSetting.setting.latitude,
          lng: accountSetting.setting.longitude
        };
      }
      this.mapConfig.zoom      = accountSetting.setting.zoom;
      this.mapConfig.mapTypeId = accountSetting.setting.map_type;
    }
    if (this.initPoint !== null) {
      this.mapConfig.zoom = this.MARKER.ZOOM;
    }
  },
  /**
   * 見た目を設定
   */
  setStyle: function () {
    this.map.setTilt(0);
    this.map.addListener('maptypeid_changed', function () {
      DataLayer.setStyleForEachMapStyle();
    });
    this.setStyleForMap();
    DataLayer.setStyleForEachMapStyle();
  },
  /**
   * 地図の見た目を設定
   */
  setStyleForMap: function () {
    const styledMapOptions = {name: 'シンプル', maxZoom: 22};
    const customMapType    = new this.google.maps.StyledMapType(this.featureOpts, styledMapOptions);
    this.map.mapTypes.set(this.CUSTOM_MAP_TYPE_ID, customMapType);
  },
  /**
   * Handle event lick on map
   *
   * @param vueMapGoogle
   */
  setClickEvent: function (vueMapGoogle) {
    const self = this;
    self.map.addListener('click', function (event) {
      // TODO click event
      Measure.setMarker(event.latLng, vueMapGoogle);
      DataLayer.setMarker(event.latLng);
      if (!self.touchSupported && self.checkClickOnChiban(event.latLng)) {
        MultiPoint.setMarker(event.latLng, vueMapGoogle)
      }
    });
    self.map.addListener('mousedown', function () {
      self.mouseDownHandler();
    });
    self.map.addListener('mouseup', function (event) {
      self.rightClickPosition = event.latLng;
      self.mouseUpHandler(event).then((e) => {
        setTimeout(function () {
          // iPad版のロングタップ（右クリック相当）
          self.rightClickHandler(e, vueMapGoogle)
        }, self.longPressTimeout);
      });
    });
    self.map.addListener('rightclick', function (event) {
      self.rightClickPosition = event.latLng;
      // PC版の右クリック
      // ※複数地点選択モードでは右クリックなし
      if (MultiPoint.getMode()) {
        return;
      }
      self.rightClickHandler(event, vueMapGoogle)
    });
  },
  /**
   * Search and move map by address
   *
   * @param vueMapGoogle
   */
  searchSubmit: function (vueMapGoogle) {
    const self       = this;
    const searchType = document.getElementById("searchType").value;
    const address    = document.getElementById("searchKeyword").value;
    if (searchType === Common.locationSearchTypes.google.code) {
      vueMapGoogle.$emit('beginSearch');
      self.searchGoogleAddress(vueMapGoogle, address);
    } else if (searchType === Common.locationSearchTypes.jon.code) {
      vueMapGoogle.$emit('beginSearch');
      self.searchJonAddress(vueMapGoogle, address);
    }
  },
  /**
   *
   * @param vueMapGoogle
   * @param address
   */
  searchGoogleAddress(vueMapGoogle, address) {
    if (Common.isNullOrEmpty(address)) {
      vueMapGoogle.$emit('requiredAddress');
      return;
    }
    const self = this;

    // 座標を入力された場合はその座標へ遷移させる
    const regexLatLng = /^([0-9.]+),\s?([0-9.]+)$/.exec(address);
    if (regexLatLng) {
      const lat           = parseFloat(regexLatLng[1]); // 緯度
      const lng           = parseFloat(regexLatLng[2]); // 経度
      const addressResult = regexLatLng[0]; // 結果メッセージ

      self.map.setCenter({lat: lat, lng: lng});
      self.map.setZoom(self.GEO_CODING.ZOOM);
      self.setGeoCodingMarker(lat, lng, vueMapGoogle);
      self.saveHistoryGeocoding({
        type     : Common.locationSearchTypes.google.code,
        keyword  : addressResult,
        latitude : lat,
        longitude: lng,
      });
      vueMapGoogle.$emit('searched');
      return;
    }

    // Google Geocodeing APIを利用してジオコーディングを行う
    this.geocoder.geocode({'address': address}, function (results, status) {
      if (status === Common.google.statusOk) {
        const lat           = results[0].geometry.location.lat();
        const lng           = results[0].geometry.location.lng();
        const addressResult = results[0].formatted_address;
        self.handleSearchResult(vueMapGoogle, address, addressResult, lat, lng, Common.locationSearchTypes.google.code);
      } else {
        vueMapGoogle.$emit('geocodingNotFound');
        self.saveHistoryGeocoding({
          type     : Common.locationSearchTypes.google.code,
          keyword  : address,
          latitude : null,
          longitude: null,
        });
      }
    });
  },
  /**
   *
   * @param vueMapGoogle
   * @param address
   */
  searchJonAddress(vueMapGoogle, address) {
    const self = this;
    if (self.cancelToken.search) {
      self.cancelToken.search.cancel();
    }

    if (Common.isNullOrEmpty(address)) {
      vueMapGoogle.$emit('requiredAddress');
      return;
    }

    const params = {
      'address': address,
      'tab_id' : sessionStorage.tabID
    };

    self.cancelToken.search = apiTool.cancelToken();
    apiClient.get(apiList.jon.locating, {params: params}, {
      headers    : {
        Authorization: "Bearer " + localStorage.getItem(Common.localStorageKeys.user.accessToken)
      },
      timeout    : self.API_TIMEOUT,
      cancelToken: self.cancelToken.search.token
    }).then(response => {
      if (response.data.errors && response.data.errors[0] && response.data.errors[0] === Common.messages.errorLimited) {
        vueMapGoogle.$emit('jonSearchNotFound', Common.messages.errorLimited);
        return;
      }
      if (response.data.errors && response.data.errors[0]) {
        // 汎用的なバックエンドから受け取ったエラーメッセージを表示させる動き
        vueMapGoogle.$emit('jonSearchNotFound', response.data.errors[0]);
        return;
      }

      if (!response.data || !response.data.lat || !response.data.long || !response.data.locating_level) {
        throw Common.messages.errorGet;
      }
      const lat           = response.data.lat;
      const lng           = response.data.long;
      const locatingLevel = response.data.locating_level;
      self.handleSearchResult(vueMapGoogle, address, address, lat, lng, Common.locationSearchTypes.jon.code, locatingLevel);
    }).catch((err) => {
      console.error('err search = ', err);
      vueMapGoogle.$emit('jonSearchNotFound');
      self.saveHistoryGeocoding({
        type     : Common.locationSearchTypes.jon.code,
        keyword  : address,
        latitude : null,
        longitude: null,
      });
    });
  },
  /**
   * In case have search result
   *
   * @param vueMapGoogle
   * @param address
   * @param addressResult
   * @param lat
   * @param lng
   * @param type
   * @param locatingLevel
   */
  handleSearchResult(vueMapGoogle, address, addressResult, lat, lng, type, locatingLevel = 0) {
    const self = this;
    self.map.setCenter({
      lat: lat,
      lng: lng
    });
    self.map.setZoom(locatingLevel === 0 ? self.GEO_CODING.ZOOM : self.MARKER.ZOOM);
    DataLayer.changeTile();
    self.changeGeoJson(vueMapGoogle);
    self.changeAccountSetting();
    self.setGeoCodingMarker(lat, lng, vueMapGoogle);

    self.saveHistoryGeocoding({
      type     : type,
      keyword  : address,
      latitude : lat,
      longitude: lng,
    });
    const searchedMessage = locatingLevel > 1 ? Common.getLocatingLevelError(locatingLevel) : null;
    vueMapGoogle.$emit('searched', searchedMessage);
  },
  /**
   * 表示範囲よりGeoJsonをオーバーレイ表示
   *
   * @param vueMapGoogle
   */
  setGeoJson: function (vueMapGoogle) {
    const self = this;
    this.map.addListener('zoom_changed', function () {
      self.changeGeoJson(vueMapGoogle);
    });
    this.map.addListener('dragend', function () {
      self.changeGeoJson(vueMapGoogle);
    });
    this.map.addListener('tilesloaded', function () {
      self.changeGeoJson(vueMapGoogle);
    });
    window.addEventListener('resize', function () {
      if (self.onWindowResize) {
        return;
      }

      self.onWindowResize = true;
      setTimeout(function () {
        self.changeGeoJson(vueMapGoogle);
        self.onWindowResize = false;
      }, 2000);
    }, false);
  },
  /**
   * Check account status
   */
  checkAccountStatus() {
    return new Promise((resolve, reject) => {
      apiClient.get(apiList.accounts.status)
        .then(response => {
          resolve(response.data.status);
        })
        .catch(error => {
          reject(false);
        });
    });
  },
  /**
   * Set account setting
   */
  setAccountSetting: function () {
    const self = this;
    this.map.addListener('zoom_changed', function () {
      self.changeAccountSetting();
    });

    this.map.addListener('maptypeid_changed', function () {
      self.changeAccountSetting();
    });

    this.map.addListener('dragend', function () {
      self.changeAccountSetting();
    });
  },
  setInterval: function () {
    this.map.addListener('zoom_changed', function () {
      this.isInterval = true;
      setTimeout(() => {
        this.isInterval = false;
      }, 1000);
    });

    this.map.addListener('maptypeid_changed', function () {
      this.isInterval = true;
      setTimeout(() => {
        this.isInterval = false;
      }, 1000);
    });

    this.map.addListener('dragend', function () {
      this.isInterval = true;
      setTimeout(() => {
        this.isInterval = false;
      }, 1000);
    });
  },

  /**
   * Get account setting
   */
  getAccountSetting: function () {
    return new Promise((resolve, reject) => {
      apiClient.get(apiList.accounts.setting, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem(Common.localStorageKeys.user.accessToken)
        }
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  },
  /**
   * Change account setting
   */
  changeAccountSetting: function () {
    const self = this;
    // 以前のリクエストが終わっていない場合はキャンセル
    if (self.cancelToken.setting) {
      self.cancelToken.setting.cancel();
    }

    const paramsRequest = {
      'center_latitude' : self.map.getCenter().lat(),
      'center_longitude': self.map.getCenter().lng(),
      'zoom'            : self.map.getZoom(),
      'map_type'        : self.map.getMapTypeId()
    };

    self.settingApiCall.add();
    Common.sleep(self.API_CALL_WAIT)
      .then(() => {
        if (self.settingApiCall.busy()) {
          // 連続して設定を反映しないようにする
          return;
        }

        self.cancelToken.setting = apiTool.cancelToken();
        apiClient.put(apiList.accounts.setting, paramsRequest, {
          headers    : {
            Authorization: "Bearer " + localStorage.getItem(Common.localStorageKeys.user.accessToken)
          },
          timeout    : self.API_TIMEOUT,
          cancelToken: self.cancelToken.setting.token
        }).then(() => {
        }).catch(err => {
          console.error('err update = ', err);
        });
      });
  },
  /**
   * Search submit
   */
  setKeywordSearch: function (vueMapGoogle) {
    const self = this;
    document.getElementById("searchSubmit").addEventListener("click", function () {
      self.searchSubmit(vueMapGoogle);
    });
  },
  /**
   * GeoJson切り替え
   */
  changeGeoJson: function (vueMapGoogle) {
    const self = this;
    const zoom = self.map.getZoom();
    if (zoom >= DataLayer.GEO_JSON.ZOOM) {
      DataLayer.fetchDataLayerGeoJson().then(() => {
        self.clearListenersForMapData();
        // GeoJsonレイヤーにイベントを紐付ける
        self.geoJsonHandles.push(self.map.data.addListener('mousedown', function () {
          self.mouseDownHandler();
        }));
        self.geoJsonHandles.push(self.map.data.addListener('mouseup', function (event) {
          self.mouseUpHandler(event).then((e) => self.rightClickGeoLayerHandler(event, vueMapGoogle))
        }));
        self.geoJsonHandles.push(self.map.data.addListener('click', function (event) {
          if (self.isLongPress) {
            self.rightClickGeoLayerHandler(event, vueMapGoogle);
          } else {
            self.clickGeoLayerHandler(event, vueMapGoogle);
          }
        }));
        self.geoJsonHandles.push(self.map.data.addListener('rightclick', function (event) {
          self.rightClickGeoLayerHandler(event, vueMapGoogle);
        }));
      });
    } else {
      DataLayer.removeGeoJson();
    }
  },
  /**
   * GeoJsonレイヤーに紐付けられたイベントリスナーをクリアする
   */
  clearListenersForMapData: function () {
    const self = this;
    this.geoJsonHandles.forEach(geoJsonHandle => {
      self.google.maps.event.removeListener(geoJsonHandle);
    });
  },
  /**
   * Draw markers of pdf registration
   *
   * @param vueMapGoogle
   * @param refreshMarkers
   */
  drawPdfMarkers: function (vueMapGoogle, refreshMarkers = true) {
    const points = this.displayMyMarkersFlag ? this.pdfMarkers : [];
    // アイコン
    const icon   = {
      url       : 'https://cdn.jon-api.com/shikaku-map/img/marker.png',
      origin    : new this.google.maps.Point(0, 0),
      anchor    : new this.google.maps.Point(16, 48),
      scaledSize: new this.google.maps.Size(32, 48),
    };

    // Config marker clicked
    const iconClicked = {
      url       : 'https://cdn.jon-api.com/shikaku-map/img/marker-clicked.png',
      origin    : new this.google.maps.Point(0, 0),
      anchor    : new this.google.maps.Point(16, 48),
      scaledSize: new this.google.maps.Size(32, 48),
    };

    const self = this;
    if (refreshMarkers) {
      const markers  = points.map(function (point, i) {
        let selectedPoint = false;
        if (MovingMyPoint.getMode()) {
          selectedPoint = MovingMyPoint.getPoints().find((p) => p.checked && p.id === point.id);
        }
        if (self.initPoint && point.lat === self.initPoint.lat && point.lng === self.initPoint.lng) {
          selectedPoint = true;
        }
        return new self.google.maps.Marker({
          position: new self.google.maps.LatLng(point.lat, point.lng),
          icon    : selectedPoint ? iconClicked : icon,
          opacity : point.opacity,
          zIndex  : 1
        });
      });
      self.initPoint = null;

      markers.forEach((marker, index) => {
        const point = points[index];
        marker.addListener('click', function (e) {
          if (self.isLongPress) {
            self.landMarkerRightClickHandler(e, vueMapGoogle, point);
            return;
          }
          // prevent when showing confirm modal
          if (self.hasConfirmDialog) {
            return;
          }
          // prevent when in measure mode
          if (Measure.getMode()) {
            return;
          }
          // prevent when in multi points mode
          if (MultiPoint.getMode()) {
            return;
          }
          // prevent when in moving my point mode
          if (MovingMyPoint.getMode() && !MovingMyPoint.getDestinationMode()) {
            marker.setIcon(iconClicked);
            MovingMyPoint.push(point);
            const movingPoints = MovingMyPoint.getPoints();
            for (let i = 0; i < markers.length; i++) {
              if (points[i].id === point.id) {
                continue;
              }
              if (self.distanceByMarkers(marker, markers[i]) <= MovingMyPoint.RADIUS) {
                MovingMyPoint.push(points[i]);
                markers[i].setIcon(iconClicked);
                continue;
              }
              if (movingPoints.find((p) => p.checked && p.id === points[i].id)) {
                markers[i].setIcon(iconClicked);
                continue;
              }
              markers[i].setIcon(icon);
            }
            return;
          }
          // 移動先指定モードでは、指定座標に移動先のマーカーを設置する
          if (MovingMyPoint.getDestinationMode()) {
            MovingMyPoint.setMarker(e.latLng);
            return;
          }

          for (let i = 0; i < markers.length; i++) {
            markers[i].setIcon(icon);
          }
          if (!MovingMyPoint.getDestinationMode()) {
            marker.setIcon(iconClicked);
          }
          self.getPdfRegistration(vueMapGoogle, parseFloat(point.lat), parseFloat(point.lng));
          vueMapGoogle.$emit('showRightSidebar');
        });
        marker.addListener('mousedown', function () {
          self.mouseDownHandler();
        });
        marker.addListener('mouseup', function (event) {
          self.mouseUpHandler(event).then((e) => {
            setTimeout(function () {
              self.landMarkerRightClickHandler(e, vueMapGoogle, point)
            }, self.longPressTimeout);
          });
        });
        marker.addListener('rightclick', function (e) {
          if (self.isNotAvailableZoomLevel(vueMapGoogle, e)) {
            return;
          }
          self.landMarkerRightClickHandler(e, vueMapGoogle, point);
        });
      });

      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
      }
      this.markerCluster = new MarkerClusterer(this.map, markers, {
        maxZoom  : DataLayer.GEO_JSON.ZOOM,
        imagePath: 'https://cdn.jon-api.com/shikaku-map/img/cluster'
      });
    }
  },
  /**
   *
   * @param vueMapGoogle
   */
  updatePdfRegistration: function (vueMapGoogle) {
    const self = this;
    this.map.addListener('zoom_changed', function () {
      self.getPdfRegistration(vueMapGoogle);
    });
    this.map.addListener('dragend', function () {
      self.getPdfRegistration(vueMapGoogle);
    });
    this.map.addListener('tilesloaded', function () {
      self.getPdfRegistration(vueMapGoogle);
    });
  },
  /**
   *
   * @param pdfActive
   */
  pdfActive: function (pdfActive) {
    // Config marker active
    const iconActive = {
      url       : 'https://cdn.jon-api.com/shikaku-map/img/circle.png',
      origin    : new this.google.maps.Point(0, 0),
      anchor    : new this.google.maps.Point(24, 24),
      scaledSize: new this.google.maps.Size(48, 48),
    };

    this.pdfActives.forEach(pdf => {
      pdf.setMap(null);
    });
    if (pdfActive !== null) {
      const activeMarker = new this.google.maps.Marker({
        position: new this.google.maps.LatLng(pdfActive.lat, pdfActive.lng),
        icon    : iconActive,
        opacity : 0.6,
        zIndex  : 0
      });
      activeMarker.setMap(this.map);
      this.pdfActives.push(activeMarker);
    }
  },
  /**
   * 地図のズーム値を取得
   * @returns {*}
   */
  getZoom: function () {
    return this.map.getZoom();
  },
  /**
   *
   * @param vueMapGoogle
   * @param lat
   * @param lng
   * @param currentPage
   * @param perPage
   */
  getPdfRegistration: function (
    vueMapGoogle,
    lat         = null,
    lng         = null,
    currentPage = 1,
    perPage     = Common.registrationLimitPage
  ) {
    const self      = this;
    const mapBounds = self.map.getBounds();
    if (!mapBounds) {
      return;
    }
    vueMapGoogle.$emit('updateMapZoom', true);
    // ズーム値が取得履歴をリクエストできる最小値だった場合、マイマーカーとリストを表示しない
    if (self.map.getZoom() < self.MARKER.REGISTRIES_REQUEST_MIN_ZOOM) {
      self.pdfMarkers = [];
      self.drawPdfMarkers(vueMapGoogle, true);
      vueMapGoogle.$emit('getPdfRegistrations', []);
      return;
    }
    vueMapGoogle.$emit('loadPdfRegistrations', true);
    self.pdfMarkers = [];
    let params      = {
      'page' : currentPage,
      'limit': perPage,
    };

    let refreshMarkers = true;
    if (lat !== null && lng !== null) {
      // マーカーをクリックされた際は
      // 1．マーカーを再描画しない。
      // 2．クリックされたマーカー座標より四方5mの範囲に該当する物件を取得する
      refreshMarkers            = false;
      params.northeast_lat_long = (lat + self.MARKER.BUFFER) + ',' + (lng + self.MARKER.BUFFER);
      params.southwest_lat_long = (lat - self.MARKER.BUFFER) + ',' + (lng - self.MARKER.BUFFER);
    } else {
      params.northeast_lat_long = mapBounds.getNorthEast().lat() + ',' + mapBounds.getNorthEast().lng();
      params.southwest_lat_long = mapBounds.getSouthWest().lat() + ',' + mapBounds.getSouthWest().lng();
    }
    if (MovingMyPoint.getMode() && !MovingMyPoint.getDestinationMode()) {
      // マイマーカーの移動は自身のマーカーに限る
      const auth        = Common.getCurrentUserInfo();
      params.account_id = auth.id;
    }

    let dataRightSidebar = [];
    const opacity        = {
      self : 1.0, // 自身
      other: 0.5, // 他者
    };

    self.markerApiCall.add();
    Common.sleep(self.API_CALL_WAIT)
      .then(() => {
        if (self.markerApiCall.busy()) {
          // 連続して登記情報取得履歴を取得しないようにする
          return;
        }

        let pdfMarkers = [];
        apiClient.get(apiList.jon.registries, {params: params})
          .then(response => {
            if (response.data.errors) {
              console.error('getPdfRegistration error: ', response.data.errors);
              return
            }
            dataRightSidebar      = response.data;
            dataRightSidebar.data = dataRightSidebar.data.filter(pdf => {
              return !self.initPoint || (pdf.latitude === self.initPoint.lat && pdf.longitude === self.initPoint.lng)
            });
            dataRightSidebar.data.forEach(pdf => {
              pdfMarkers.push({
                id         : pdf.id,
                label      : pdf.label,
                lat        : pdf.latitude,
                lng        : pdf.longitude,
                opacity    : pdf.account_id === vueMapGoogle.accountId ? opacity.self : opacity.other,
                v1Code     : pdf.v1_code,
                number     : pdf.number,
                number_type: pdf.number_type,
                pdf_type   : pdf.pdf_type,
              });
            });
            self.pdfMarkers = pdfMarkers;
          })
          .catch(error => {
            console.error('getPdfRegistration error: ', error.message);
          })
          .finally(() => {
            vueMapGoogle.$emit('loadPdfRegistrations', false);
            self.drawPdfMarkers(vueMapGoogle, refreshMarkers);
            vueMapGoogle.$emit('getPdfRegistrations', dataRightSidebar);
          });
      });
  },
  /**
   * 地番地図をオーバーレイ表示する
   *
   * @param vueMapGoogle
   */
  initChibanOverlay: function (vueMapGoogle) {
    const self = this;
    self.temporaryHideImages();
    if (!self.google) {
      self.vueMapGoogle = vueMapGoogle;
      return;
    }
    const chibanLists     = vueMapGoogle.chibanLists;
    const closeButtonIcon = {
      url       : 'https://cdn.jon-api.com/shikaku-map/img/close.png',
      origin    : new self.google.maps.Point(0, 0),
      anchor    : new self.google.maps.Point(11, 11),
      scaledSize: new self.google.maps.Size(22, 22),
    };
    chibanLists.forEach((chiban, index) => {
      // Add to polygon
      const polygonCoords = [
        {lat: chiban.imageBounds.north, lng: chiban.imageBounds.west},
        {lat: chiban.imageBounds.north, lng: chiban.imageBounds.east},
        {lat: chiban.imageBounds.south, lng: chiban.imageBounds.east},
        {lat: chiban.imageBounds.south, lng: chiban.imageBounds.west}
      ];
      const chibanPolygon = new self.google.maps.Polygon({paths: polygonCoords});
      self.chibanPolygons.push(chibanPolygon);

      // Draw chiban_image
      const chibanOverlay = new self.google.maps.GroundOverlay(
        chiban.imageSrc,
        chiban.imageBounds,
        {clickable: false}
      );
      chibanOverlay.setOpacity(0.5);
      chibanOverlay.setMap(self.map);
      self.chibanOverlays.push(chibanOverlay);
      // Add close maker
      const closeButtonMarker = new self.google.maps.Marker({
        position: new self.google.maps.LatLng(chiban.imageBounds.north, chiban.imageBounds.east),
        icon    : closeButtonIcon,
        opacity : 0.6,
        zIndex  : 0
      });
      closeButtonMarker.addListener('click', function () {
        // prevent when showing confirm modal
        if (self.hasConfirmDialog) {
          return;
        }
        // prevent when in measure mode
        if (Measure.getMode()) {
          return;
        }
        // prevent when in multi points mode
        if (MultiPoint.getMode()) {
          return;
        }
        // prevent when in moving my point mode
        if (MovingMyPoint.getMode()) {
          return;
        }
        const newList = chibanLists.filter((el, i) => i !== index);
        vueMapGoogle.$emit('refreshChibanLists', newList);

        apiClient.delete(apiList.history.chibans, {
          data: {
            processed_at: chiban.processedAt
          }
        }).then(response => {
        }).catch(error => {
          console.error(error);
        });
      });
      closeButtonMarker.setMap(self.map);
      self.chibanCloses.push(closeButtonMarker);
    });
    self.vueMapGoogle = null;
  },
  initNALayerOverlay  : function () {
    const mvtLayer = this.createNALayer();
    this.overlay   = new GoogleMapsOverlay({
      layers           : [mvtLayer],
      onHover          : (info, event) => {
        this.isNaLayerHover = info.picked;
      },
      onClick          : (info, event) => {
        this.isNaLayerHover = info.picked;
      },
    });
    this.overlay.setMap(this.map);
  },
  createNALayer       : function (isVisible = true) {
    return new MVTLayer({
      id            : 'na',
      data          : [this.NA_LAYER_URL + '{z}/{x}/{y}'],
      minZoom       : 15,
      maxZoom       : 23,
      tileSize      : 256,
      getFillColor  : f => {
        if (isVisible) {
          if(f.properties.is_national_forest === 1){
            return [55, 126, 184, 107];
          }
          return [255, 66, 101, 51.2];
        } else {
          return [0, 0, 0, 0];
        }
      },
      getLineWidth  : () => {
        if (isVisible) {
          return 0.1;
        } else {
          return 0;
        }
      },
      getLineColor  : () => {
        if (isVisible) {
          return [255, 66, 101, 51.2];
        } else {
          return [0, 0, 0, 0];
        }
      },
      picking       : true,
      pickable      : true,
      onTileError   : null,
      updateTriggers: {
        getFillColor: this.isNaVisible,
        getLineWidth: this.isNaVisible,
        getLineColor: this.isNaVisible,
      }
    })
  },
  updateNALayerVisible: function (visible = false) {
    this.isNaVisible = visible || (DataLayer.selectedDataLayer?.code ?? '') === DataLayer.types.naLayer.code;
    this.overlay.setProps({layers: [this.createNALayer(this.isNaVisible)]});
  },
  /**
   * 地番地図をクリックした時、その座標が地番地図上か判断する
   *
   * @param latLng
   * @returns {boolean}
   */
  checkClickOnChiban(latLng) {
    for (let i = 0; i < this.chibanPolygons.length; i++) {
      if (this.google.maps.geometry.poly.containsLocation(latLng, this.chibanPolygons[i])) {
        return true;
      }
    }
    return false;
  },
  /**
   * 表示／非表示ボタン
   * 地番地図に関連する情報を初期化する
   */
  temporaryHideImages() {
    this.chibanCloses.forEach(close => {
      close.setMap(null);
    });
    this.chibanPolygons.forEach(polygon => {
      polygon.setMap(null);
    });
    this.chibanOverlays.forEach(overlay => {
      overlay.setMap(null);
    });
    this.chibanCloses   = [];
    this.chibanPolygons = [];
    this.chibanOverlays = [];
  },
  displayMyMakers(vueMapGoogle, displayFlag) {
    this.displayMyMarkersFlag = displayFlag;
    this.drawPdfMarkers(vueMapGoogle);
  },
  /**
   * 地図の中心を移動させる
   *
   * @param centerPoint
   * @param addMarker
   * @param vueMapGoogle
   */
  changeCenterPoint: function (centerPoint, addMarker = false, vueMapGoogle = null) {
    this.mapConfig.center = {
      lat: centerPoint.lat,
      lng: centerPoint.lng
    };
    this.map.setCenter(new self.google.maps.LatLng(centerPoint.lat, centerPoint.lng));
    if (addMarker) {
      this.addRightClickMarker(this.map.getCenter(), vueMapGoogle);
    }
  },
  /**
   * @param point
   */
  setInitPoint(point) {
    this.initPoint = point;
  },
  /**
   * GoogleMapを表示した履歴を残す
   *
   * @returns {Promise<unknown>}
   */
  saveHistoryMap: function () {
    return new Promise((resolve, reject) => {
      apiClient
        .post(apiList.history.maps)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  /**
   * 検索履歴を残す
   *
   * @param data
   * @returns {Promise<unknown>}
   */
  saveHistoryGeocoding: function (data) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(apiList.history.geocodings, data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },
  /**
   * ジオコーディング後のマーカーを設定
   *
   * @param lat
   * @param lng
   * @param vueMapGoogle
   */
  setGeoCodingMarker: function (lat, lng, vueMapGoogle) {
    const self = this;
    self.removeRightClickMarker();
    self.rightClickMarker = new self.google.maps.Marker({
      position: new self.google.maps.LatLng(lat, lng),
      zIndex  : 1,
    });
    self.infoWindow       = new this.google.maps.InfoWindow();
    self.rightClickMarker.addListener('mousedown', function () {
      self.mouseDownHandler();
    });
    self.rightClickMarker.addListener('mouseup', function (event) {
      self.mouseUpHandler(event).then((e) => {
        setTimeout(function () {
          self.clickRightClickMarkerHandler(e, vueMapGoogle)
        }, self.longPressTimeout);
      });
    });
    self.rightClickMarker.addListener('rightclick', function (e) {
      self.clickRightClickMarkerHandler(e, vueMapGoogle);
    });
    self.rightClickMarker.addListener('click', function (e) {
      if (self.isLongPress) {
        setTimeout(function () {
          self.clickRightClickMarkerHandler(e, vueMapGoogle)
        }, self.longPressTimeout);
        return;
      }
      // prevent when showing confirm modal
      if (self.hasConfirmDialog) {
        return;
      }
      // prevent when in measure mode
      if (Measure.getMode()) {
        return;
      }
      // prevent when in multi points mode
      if (MultiPoint.getMode()) {
        return;
      }
      // prevent when in moving my point mode
      if (MovingMyPoint.getMode()) {
        return;
      }
      if (self.coordInfoWindow === null) {
        self.coordInfoWindow = new self.google.maps.InfoWindow();
      }
    });
    self.rightClickMarker.setMap(self.map);
  },
  /**
   * 右クリック可能なマーカーをクリックしたときの挙動
   *
   * @param e
   * @param vueMapGoogle
   */
  clickRightClickMarkerHandler: function (e, vueMapGoogle) {
    const self       = this;
    self.isLongPress = false;
    // prevent when showing confirm modal
    if (self.hasConfirmDialog) {
      return;
    }
    // prevent when in measure mode
    if (Measure.getMode()) {
      return;
    }
    // prevent when in moving my point mode
    if (MovingMyPoint.getMode()) {
      return;
    }
    const point = {
      lat: self.rightClickMarker.position.lat(),
      lng: self.rightClickMarker.position.lng(),
    };
    // prevent when in multi points mode
    if (MultiPoint.getMode()) {
      if (self.checkClickOnChiban(self.rightClickMarker.position)) {
        vueMapGoogle.$emit('landMarkerRightClick', {e, point});
      }
      return;
    }
    self.getDataPoint(vueMapGoogle, point).then();

    // 右クリック可能なマーカーなポジションを右クリックポジションとして保持する
    // ※ジオコーディングしたポジションを右クリックし、複数地点選択モードの1点目の初期値とする
    this.rightClickPosition = self.rightClickMarker.position;

    if (self.checkClickOnChiban(self.rightClickMarker.position)) {
      vueMapGoogle.$emit('landMarkerRightClick', {e, point});
    } else {
      vueMapGoogle.$emit('mapMarkerRightClick', {e, point})
    }
  },
  /**
   * 右クリックマーカーを削除
   */
  removeRightClickMarker: function () {
    if (this.rightClickMarker) {
      this.rightClickMarker.setMap(null);
    }
  },
  /**
   * ブラウザのズームレベルが100%か
   *
   * @returns {boolean}
   */
  browserZoomLevel100: function () {
    // TODO: Windows10で「表示スケール」を150%にすると window.devicePixelRatio 1.5になってしまうため一旦解除
    // return window.devicePixelRatio === 1;
    return true;
  },
  /**
   * 指定座標の情報を取得する
   *
   * @param vueMapGoogle
   * @param latLng
   * @return {Promise<any>}
   */
  getDataPoint(vueMapGoogle, latLng) {
    const self      = this;
    self.dataPoints = null;
    return new Promise((resolve, reject) => {
      // get AcaContentApi
      if (self.cancelToken.point) {
        self.cancelToken.point.cancel();
      }

      self.cancelToken.point = apiTool.cancelToken();
      const paramsRequest    = {
        params     : {
          latitude : latLng.lat,
          longitude: latLng.lng,
        },
        timeout    : self.API_TIMEOUT,
        cancelToken: self.cancelToken.point.token
      };
      vueMapGoogle.$emit('setLoadPoint', true);

      apiClient.get(apiList.jon.point, paramsRequest).then(response => {
        self.dataPoints = response.data;
        vueMapGoogle.$emit('getMapInit', self);
        resolve();
      }).catch((err) => {
        if (!axios.isCancel(err)) {
          vueMapGoogle.$emit('setLoadPoint', false);
        }
        console.error('err point = ', err);
      }).finally(() => {
      });
    });
  },
  /**
   *
   * @param vueMapGoogle
   * @returns {Promise<unknown>}
   */
  getDataMultiPoint(vueMapGoogle) {
    const self            = this;
    let promisePointArray = MultiPoint.getPoints().map((position) => {
      const paramsRequest = {
        params     : {
          latitude : position.lat(),
          longitude: position.lng(),
        },
        timeout    : self.API_TIMEOUT,
        cancelToken: self.cancelToken.point.token
      };
      return apiClient.get(apiList.jon.point, paramsRequest);
    });

    self.dataMultiPoints = [];
    return new Promise((resolve, reject) => {
      axios
        .all(promisePointArray)
        .then(axios.spread((...responses) => {
          responses.map((response) => {
            self.dataMultiPoints.push(response.data);
          });
          vueMapGoogle.$emit('getMapMultiPointInit', self);
          resolve();
        }))
        .catch(err => {
          if (!axios.isCancel(err)) {
            vueMapGoogle.$emit('setLoadMultiPoint', false);
          }
          reject(err);
        })
        .finally(() => {
        });
    });
  },
  /**
   * 地番確認ウィンドウを表示させる
   *
   * @param hasConfirmDialog
   */
  setShowConfirmDialog: function (hasConfirmDialog) {
    this.hasConfirmDialog = hasConfirmDialog;
    // Change zoom and street view control
    this.map.setOptions({
      streetViewControl: !this.hasConfirmDialog,
    });
  },
  /**
   * @param vueMapGoogle
   * @param mode
   */
  changeMeasureMode: function (vueMapGoogle, mode) {
    Measure.setMode(mode);
    if (this.rightClickMarker) {
      this.rightClickMarker.setMap(null);
    }
  },
  /**
   * Remove all measure markers
   */
  clearMeasureMarkers: function () {
    Measure.clearMarkers();
  },
  /**
   *
   * @param vueMapGoogle
   * @param mode
   */
  changeMultiPointMode: function (vueMapGoogle, mode) {
    MultiPoint.setMode(mode);
    this.multiPointMode = mode;
    if (this.multiPointMode) {
      // draw marker
      MultiPoint.init(this, this.google, this.map, vueMapGoogle).then(() => {
        MultiPoint.setMarker(this.rightClickPosition, vueMapGoogle);
      });
    } else {
      // clear marker
      MultiPoint.clearMarkers();
    }
  },
  /**
   * @param vueMapGoogle
   * @param mode
   */
  changeMovingMyPointMode: function (vueMapGoogle, mode) {
    this.removeRightClickMarker();
    MovingMyPoint.setMode(mode);
  },
  /**
   *
   * @param vueMapGoogle
   * @param mode
   */
  changeDestinationPointMode: function (vueMapGoogle, mode) {
    MovingMyPoint.setDestinationMode(mode);
  },
  /**
   * Mouse down event handler
   */
  mouseDownHandler() {
    const self           = this;
    self.isLongPress     = false;
    self.mouseDownAt     = new Date().getTime();
    self.mouseDownCenter = self.map.getCenter();
  },
  /**
   * Mouse up event handler
   */
  mouseUpHandler(e) {
    const self       = this;
    self.isLongPress = false;
    return new Promise((resolve) => {
      // Not support touch
      if (!self.touchSupported) {
        return;
      }
      // Not down on Map
      if (!self.mouseDownAt) {
        return;
      }
      // Up too quickly
      const mouseUpAt = new Date().getTime();
      if (mouseUpAt - self.mouseDownAt <= self.longPressTime) {
        return;
      }
      // Drag map
      if (self.mouseDownCenter) {
        const centerPoint = self.map.getCenter();
        if (centerPoint.lat() !== self.mouseDownCenter.lat() || centerPoint.lng() !== self.mouseDownCenter.lng()) {
          return;
        }
      }
      self.mouseDownAt     = null;
      self.mouseDownCenter = null;
      self.isLongPress     = true;
      return resolve(e);
    });
  },
  /**
   * Right click on map handler
   *
   * @param e
   * @param vueMapGoogle
   */
  async rightClickHandler(e, vueMapGoogle) {
    vueMapGoogle.$emit('beforeRightClick', e);

    const self       = this;
    self.isLongPress = false;
    // prevent when showing confirm modal
    if (self.hasConfirmDialog) {
      return;
    }
    // prevent when in measure mode
    if (Measure.getMode()) {
      return;
    }
    // prevent when in moving my point mode
    if (MovingMyPoint.getMode()) {
      return;
    }
    // prevent when in multi points mode
    if (MultiPoint.getMode()) {
      self.addRightClickMarker(e.latLng, vueMapGoogle);
      if (self.checkClickOnChiban(e.latLng)) {
        vueMapGoogle.$emit('landMapClicked', e);
      }
      return;
    }
    if (!self.browserZoomLevel100()) {
      // ズームレベルが100％でないと右クリックしたときの座標がおかしいため100%固定
      const message = Common.messages.map.notZoomLevel100;
      vueMapGoogle.$emit('rightClick', {e, message});
      return;
    }

    // クリックした場所がJON地番地図か
    const latLng = e.latLng;
    if (self.checkClickOnChiban(latLng)) {
      vueMapGoogle.$emit('landMapClicked', e);
      self.addRightClickMarker(latLng, vueMapGoogle);
      return;
    }

    // JON地番地図が表示できないズームレベルか
    if (this.isNotAvailableZoomLevel(vueMapGoogle, e)) {
      return;
    }

    // クリックした場所がNA範囲か
    if (this.isNaLayerHover) {
      const message = Common.messages.map.rightClickGeoLayer;
      vueMapGoogle.$emit('rightClick', {e, message});
      return;
    }

    // 関数内で処理している地点と、最新の右クリックされた地点が等しい（変更がない）場合にマーカー設置＆イベント通知
    if (latLng === self.rightClickPosition) {
      // マーカーを右クリックした場所に落とす
      vueMapGoogle.$emit('rightClick', {e});
      self.addRightClickMarker(latLng, vueMapGoogle);
    }
  },
  /**
   *
   * @param latLng
   * @param vueMapGoogle
   */
  addRightClickMarker(latLng, vueMapGoogle) {
    const self = this;
    self.removeRightClickMarker();

    // Add marker
    self.rightClickMarker = new self.google.maps.Marker({
      map     : self.map,
      position: latLng,
    });
    this.infoWindow       = new this.google.maps.InfoWindow();
    self.rightClickMarker.addListener('mousedown', function () {
      self.mouseDownHandler();
    });
    self.rightClickMarker.addListener('mouseup', function (event) {
      self.mouseUpHandler(event).then((e) => {
        setTimeout(function () {
          self.clickRightClickMarkerHandler(e, vueMapGoogle)
        }, self.longPressTimeout);
      });
    });
    self.rightClickMarker.addListener('rightclick', function (e) {
      if (self.isNotAvailableZoomLevel(vueMapGoogle, e)) {
        return;
      }
      self.clickRightClickMarkerHandler(e, vueMapGoogle);
    });
    if (this.multiPointMode && self.checkClickOnChiban(latLng)) {
      self.removeRightClickMarker();
      MultiPoint.init(this, this.google, this.map, vueMapGoogle).then(() => {
        MultiPoint.setMode(true).setMarker(this.rightClickPosition, vueMapGoogle);
      });
    } else {
      self.rightClickMarker.setMap(self.map);
      self.getDataPoint(vueMapGoogle, {
        lat: latLng.lat(),
        lng: latLng.lng(),
      }).then();
    }
  },
  /**
   * Right click on land marker event handler
   *
   * @param e
   * @param vueMapGoogle
   * @param point
   */
  landMarkerRightClickHandler(e, vueMapGoogle, point) {
    const self       = this;
    self.isLongPress = false;
    // prevent when showing confirm modal
    if (self.hasConfirmDialog) {
      return;
    }
    // prevent when in measure mode
    if (Measure.getMode()) {
      return;
    }
    // prevent when in multi points mode
    if (MultiPoint.getMode()) {
      return;
    }
    // prevent when in moving my point mode
    if (MovingMyPoint.getMode()) {
      return;
    }
    // PC版取得済みマーカーを右クリックした際、位置情報を記録する前に処理を抜ける
    if (point.v1Code) {
      return;
    }

    self.getDataPoint(vueMapGoogle, point).then();
    vueMapGoogle.$emit('landMarkerRightClick', {e, point});
  },
  /**
   * Right click event on geo layer event handler
   *
   * @param event
   * @param vueMapGoogle
   */
  rightClickGeoLayerHandler(event, vueMapGoogle) {
    const self       = this;
    self.isLongPress = false;
    // prevent when showing confirm modal
    if (self.hasConfirmDialog) {
      return;
    }
    // prevent when in measure mode
    if (Measure.getMode()) {
      return;
    }
    // prevent when in multi points mode
    if (MultiPoint.getMode()) {
      return;
    }
    // prevent when in moving my point mode
    if (MovingMyPoint.getMode()) {
      return;
    }
    if (event.feature.getProperty('type') !== DataLayer.types.naLayer.code) {
      setTimeout(function () {
        self.rightClickHandler(event, vueMapGoogle);
      }, self.longPressTimeout);
      return;
    }
    vueMapGoogle.$emit('rightClickGeoLayer');
  },
  /**
   * Click event on geo layer event handler
   *
   * @param event
   * @param vueMapGoogle
   */
  clickGeoLayerHandler(event, vueMapGoogle) {
    Measure.setMarker(event.latLng, vueMapGoogle);
    DataLayer.setMarker(event.latLng);
  },
  /**
   * 長押し状態を返す
   *
   * @returns {boolean}
   */
  getIsLongPress() {
    return this.isLongPress;
  },
  /**
   * メジャーモードの初期マーカーを設定する
   *
   * @param vueMapGoogle
   */
  setFirstMeasureMarker(vueMapGoogle) {
    // メジャー機能の初期化
    Measure.init(this, this.google, this.map, vueMapGoogle).then(() => {
      Measure.setMode(true).setMarker(this.rightClickPosition, vueMapGoogle);
    });
  },
  /**
   *
   * @param vueMapGoogle
   */
  setFirstMultiPointMarker(vueMapGoogle) {
    this.removeRightClickMarker();
    MultiPoint.init(this, this.google, this.map, vueMapGoogle).then(() => {
      MultiPoint.setMode(true).setMarker(this.rightClickPosition, vueMapGoogle);
    });
  },
  /**
   * JON地番地図が表示できないズームレベル
   *
   * @param vueMapGoogle
   * @param e
   */
  isNotAvailableZoomLevel(vueMapGoogle, e) {
    if (this.map.getZoom() >= DataLayer.GEO_JSON.ZOOM) {
      return false;
    }
    const message = Common.messages.map.notAvailableZoomLevel;
    vueMapGoogle.$emit('rightClick', {e, message});
    return true;
  },
  /**
   * Compute distance of two markers
   *
   * @param marker1
   * @param marker2
   * @returns distance in meters
   */
  distanceByMarkers(marker1, marker2) {
    const path = [];
    path.push(marker1.getPosition())
    path.push(marker2.getPosition())
    return this.google.maps.geometry.spherical.computeLength(path);
  },
  /**
   * Compute distance of two locations
   *
   * @param location1
   * @param location2
   * @returns distance in meters
   */
  distance(location1, location2) {
    return this.google.maps.geometry.spherical.computeLength([location1, location2]);
  },
  showAddress(vueMapGoogle) {
    this.fetchMarkerInformation();
    vueMapGoogle.$emit('addressShowed');
  },
  fetchMarkerInformation() {
    const self = this;
    this.geocoder.geocode({location: this.rightClickMarker.getPosition()}, function (results, status) {
      if (status === Common.google.statusOk) {
        const result           = self.getPrioritizedAddress(results);
        const noCountryAddress = result.formatted_address.match(/^.*、(.*)/)[1];
        const content          = `<div>${noCountryAddress}</div>`;
        self.infoWindow.setContent(content);
        if (result.geometry.location_type === "ROOFTOP") {
          self.rightClickMarker.setPosition(result.geometry.location);
        }
        self.infoWindow.open({
          anchor     : self.rightClickMarker,
          shouldFocus: false,
        });
      }
    });
  },
  /**
   * Sort results in priority order and return appropriate address.
   *
   * @param results
   * @returns result
   */
  getPrioritizedAddress(results) {
    const self = this;
    // If the first results[0] is 'ROOFTOP', it is immediately adopted.
    if (results[0].geometry.location_type === "ROOFTOP") {
      return results[0];
    }
    // Sort results in order of GeocodingAddressTypes priority.
    const sortedResults = results.map(r => {
      r.priority = self.geocodingAddressType.indexOf(r.types[0]);
      if (r.priority === -1) r.priority = 99; // Set to 99 because undefined value is returned in rare cases.
      return r;
    }).sort((a, b) => {
      if (a.priority < b.priority) return -1;
      else if (a.priority > b.priority) return 1;
      return 0;
    });
    // 'political' is the highest priority, but if 'ROOFTOP' is available, it will be adopted.
    if (sortedResults[0].types[0] !== "political") {
      return sortedResults.map(r => {
        if (r.geometry.location_type === "ROOFTOP") {
          return r;
        }
      });
    }
    return sortedResults[0];
  }
}